import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep3_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F53.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame53() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {

    }, [])

    
        return (
            <div className="F53_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F53_entryBox">
                    <div className="F53_paragraph">
                        {language === 'english' ?
                            <p className="F53_paragraphEnglish">Saira has been having honest conversations with her elder sister and school teacher, which made her informed and knowledgeable about menstruation. She, in fact, helped her school teacher realize the need for establishing a dedicated sanitary station in her school around which there is a lot of conversation taking place among school girls</p>
                            :
                            <p className="F53_paragraphUrdu">جب سے سائرا کو ماہواری آئی ہے وہ اپنی بڑی بہن اور ٹیچر سے اس بارے میں بات کرتی ہے، جس کی وجہ سے اس کے پاس کافی معلومات اکھٹی ہو گئی ہیں۔ اس نے اپنی ٹیچر کی مدد سے سکول میں سینیٹری سٹیشن بھی بنایا ہے جس کو لے کے آج کل سکول میں کافی باتیں ہو رہی ہیں۔</p>
                        }
                    </div>

                    <div className="F53_timeline">
                        <div className='F53_timelineBar'>
                            <div className='F53_timelineFill'></div>
                            <span className='F53_timelineText'>3/14</span>
                        </div>
                    </div>

                    <div className="F53_nextFrames">
                        <div className="F53_nextFrame1"></div>
                        <div className="F53_nextFrame2"></div>
                        <div className="F53_nextFrame3"></div>
                    </div>

                    <div className='F53_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep3_lastVisitFrame(3)) }} className='F53_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    
}

export default Frame53;